import regions from './address-regions.json' with {type:'json'};

export const addressRegions = regions;
export const foldLocation = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim().toLocaleLowerCase();
export function regionOption(country, value) {
 const folded=foldLocation(value);
 return folded ? regions[country]?.options.find(o=>[o.value,o.label,...o.aliases].some(a=>foldLocation(a)===folded)) : undefined;
}
export function normalizeAddress(address) {
 return {...address,province:regionOption(address.country,address.province)?.value || address.province || ''};
}
export function invalidRegion(address) {
 const rule=regions[address.country];
 if(!rule?.options.length)return false;
 return address.province ? !regionOption(address.country,address.province) : rule.required;
}
export function updateLocation(address, field, value) {
 if(address[field]===value)return address;
 if(field==='country')return {...address,country:value,province:'',city:'',postalCode:''};
 if(field==='province')return {...address,province:value,city:'',postalCode:''};
 return {...address,[field]:value};
}
export function citySuggestions(rows, country, province, query, limit=12) {
 const region=regionOption(country,province)?.value, needle=foldLocation(query);
 const matches=rows.filter(([name,area,alias])=>(!region||!area||region===area)&&(!needle||foldLocation(name).includes(needle)||foldLocation(alias).includes(needle)));
 if(needle)matches.sort((a,b)=>Number(foldLocation(b[0]).startsWith(needle))-Number(foldLocation(a[0]).startsWith(needle)));
 return matches.slice(0,limit);
}
const cache=new Map();
export function loadCities(country) {
 if(!regions[country])return Promise.resolve([]);
 if(!cache.has(country))cache.set(country,fetch(`/address-data/20261016/${country}.json`,{credentials:'omit'}).then(r=>{if(!r.ok)throw Error('City suggestions unavailable');return r.json();}).catch(error=>{cache.delete(country);throw error;}));
 return cache.get(country);
}
